export default "__VITE_PUBLIC_ASSET__f48c1f99__"